import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Container } from './ui/Container';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300" data-id="element-33">
      <Container className="py-12 md:py-16" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12" data-id="element-35">
          <div className="col-span-1 md:col-span-1" data-id="element-36">
            <Link to="/" className="flex items-center mb-4" aria-label="Brixen Credit home" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/3GeeoPJ4JtBVoJy9fXwUA9/Asset_11x.png" alt="Brixen Credit" className="h-9 w-auto" data-id="element-38" />
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed mb-6" data-id="element-39">
              Financial education and strategic consulting to help you
              understand your credit profile and make informed decisions.
            </p>
          </div>

          <div data-id="element-40">
            <h3 className="text-white font-semibold mb-4" data-id="element-41">Services</h3>
            <ul className="space-y-3 text-sm" data-id="element-42">
              <li data-id="element-43">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-44">
                  Credit Profile Analysis
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-46">
                  Credit Education
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-48">
                  Financial Literacy
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-50">
                  Readiness Consulting
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-51">
            <h3 className="text-white font-semibold mb-4" data-id="element-52">Company</h3>
            <ul className="space-y-3 text-sm" data-id="element-53">
              <li data-id="element-54">
                <Link to="/about" className="hover:text-blue-400 transition-colors" data-id="element-55">
                  About Us
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/contact" className="hover:text-blue-400 transition-colors" data-id="element-57">
                  Contact
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors" data-id="element-59">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/terms-and-conditions" className="hover:text-blue-400 transition-colors" data-id="element-61">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/refund-policy" className="hover:text-blue-400 transition-colors" data-id="element-63">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-64">
            <h3 className="text-white font-semibold mb-4" data-id="element-65">Contact</h3>
            <ul className="space-y-3 text-sm" data-id="element-66">
              <li className="font-medium text-slate-200" data-id="element-67">BRIXEN CREDIT LLC</li>
              <li data-id="element-68">
                <a href="mailto:info@brixencredit.com" className="flex items-center hover:text-blue-400 transition-colors" data-id="element-69">
                  <Mail className="h-4 w-4 mr-2 text-blue-500" data-id="element-70" />
                  info@brixencredit.com
                </a>
              </li>
              <li data-id="element-71">
                <a href="tel:7863763985" className="flex items-center hover:text-blue-400 transition-colors" data-id="element-72">
                  <Phone className="h-4 w-4 mr-2 text-blue-500" data-id="element-73" />
                  (786) 376-3985
                </a>
              </li>
              <li className="flex items-start" data-id="element-74">
                <MapPin className="h-4 w-4 mr-2 text-blue-500 mt-1" data-id="element-75" />
                <span data-id="element-76">
                  390 NE 191ST ST STE 8123
                  <br data-id="element-77" />
                  Miami, FL 33179
                </span>
              </li>
              <li className="flex items-start" data-id="element-78">
                <Clock className="h-4 w-4 mr-2 text-blue-500 mt-1" data-id="element-79" />
                <span data-id="element-80">Monday – Saturday, 9am – 9pm EST</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 pb-6" data-id="element-81">
          <div className="flex flex-wrap justify-center gap-6 mb-8 text-xs" data-id="element-82">
            <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors" data-id="element-83">
              Privacy Policy
            </Link>
            <span className="text-slate-600" data-id="element-84">|</span>
            <Link to="/terms-and-conditions" className="hover:text-blue-400 transition-colors" data-id="element-85">
              Terms & Conditions
            </Link>
            <span className="text-slate-600" data-id="element-86">|</span>
            <Link to="/refund-policy" className="hover:text-blue-400 transition-colors" data-id="element-87">
              Refund Policy
            </Link>
          </div>

          {/* Prominent compliance disclaimer */}
          <div className="bg-slate-800/60 border border-slate-700 rounded-lg p-6 mb-6" data-id="element-88">
            <p className="font-semibold text-slate-200 mb-3 text-sm" data-id="element-89">
              Important Disclaimer
            </p>
            <p className="text-xs text-slate-400 leading-relaxed" data-id="element-90">
              BRIXEN CREDIT LLC provides educational and consulting services
              only. We do not guarantee specific outcomes, credit score
              increases, approvals, or financial results. We are not a credit
              bureau, lender, or law firm. Results vary by individual financial
              profile. We do not provide "credit repair" services as defined by
              the Credit Repair Organizations Act (CROA). We do not dispute
              items on your credit report. Our services are strictly limited to
              education, analysis, and strategic consulting.
            </p>
          </div>

          <p className="text-xs text-slate-500 text-center" data-id="element-91">
            &copy; {new Date().getFullYear()} BRIXEN CREDIT LLC. All rights
            reserved.
          </p>
        </div>
      </Container>
    </footer>;
}